// extracted by mini-css-extract-plugin
export default {"labels":"lsf-labels","labels_hidden":"lsf-labels_hidden","labels_inline":"lsf-labels_inline","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630378653
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  